export const searchStore = {
  state: {
    recipeTagsSearch: [],
    productTagsSearch: [],
    recipePage: 1,
    productPage: 1,
    recipeSearch: "",
    productSearch: ""
  },
  getters: {
    getRecipeTagsSearch(state) {
      return state.recipeTagsSearch;
    },
    getProductTagsSearch(state) {
      return state.productTagsSearch;
    },
    getRecipePage(state) {
      return state.recipePage;
    },
    getProductPage(state) {
      return state.productPage;
    },
    getRecipeSearch(state) {
      return state.recipeSearch;
    },
    getProductSearch(state) {
      return state.productSearch;
    }
  },
  mutations: {
    setRecipeTagsSearch(state, value) {
      state.recipeTagsSearch = value;
    },
    setProductTagsSearch(state, value) {
      state.productTagsSearch = value;
    },
    setRecipePage(state, value) {
      state.recipePage = value;
    },
    setProductPage(state, value) {
      state.productPage = value;
    },
    setRecipeSearch(state, value) {
      state.recipeSearch = value;
    },
    setProductSearch(state, value) {
      state.productSearch = value;
    }
  },
  actions: {}
};
